import { useEffect, useRef, useState } from 'react';

export const useSearchDebound = (
    setIsLoading: (val: boolean) => void,
    setSearchItems: (keyword: string) => void
) => {
    const [keyword, setKeyword] = useState('');
    const timeout = useRef<NodeJS.Timeout>();

    useEffect(() => {
        setIsLoading(true);
        timeout.current = setTimeout(() => {
            setSearchItems(keyword);
            setIsLoading(false);
        }, 1000);

        return () => {
            clearTimeout(timeout.current);
        };
    }, [keyword, setIsLoading, setSearchItems]);

    return {
        keyword,
        setKeyword,
    };
};
